import { UserRole } from "../domain/userRole";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { authSelector } from "../redux/selectors";

export const useIsAdmin = () => {
  const { isInRole } = useAuth(authSelector);

  const isAdmin = isInRole(
    UserRole.ITAdmin,
    UserRole.AOAdmin,
    UserRole.CCEAQualAdmin,
    UserRole.CCEAAccreditationAdmin
  );

  return isAdmin;
};


export const useIsOfqualAdmin = () => {
  const { isInRole } = useAuth(authSelector);

  return isInRole(
    UserRole.ITAdmin,
    UserRole.OfqualRegulatoryAdmin,
  );
};